export default __webpack_public_path__ + "static/media/logo.2b2bd59b.svg";